import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SlotInterface} from "@interfaces/orders/available-slots.interface";
import {CloseButtonComponent} from "../../../../shared-modules/global/close-button/close-button.component";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";
import {ToLocalDatePipe} from "../../../../pipes/date-methodes/to-local-date.pipe";
import {NgClass, NgForOf} from "@angular/common";

@Component({
  selector: 'app-select-delivery-time',
  standalone: true,
  imports: [
    CloseButtonComponent,
    TranslateModule,
    FormsModule,
    ToLocalDatePipe,
    NgForOf,
    NgClass
  ],
  templateUrl: './select-delivery-time.component.html',
  styleUrl: './select-delivery-time.component.scss'
})
export class SelectDeliveryTimeComponent {

  itemStartValue!: SlotInterface;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: Array<SlotInterface>,
  ) {}

  confirmTime(): void {
    this.dialogRef.close(this.itemStartValue);
  }

  close(): void {
    this.dialogRef.close()
  }

}
